// extracted by mini-css-extract-plugin
export default {"dataGrid":"dataGrid_rBY4D"};